/** A box in viewport pixels. */
export interface GrowthBox {
  left: number
  top: number
  width: number
  height: number
}

/**
 * Where a picture shaped like `to` starts when it grows out of `from` (a camera's circle or preview) without squashing:
 * the box of `to`'s shape that covers `from`, centred on it, as an offset from `to`'s top left and one scale for both
 * axes (about the top left).
 */
export function growthFrom(from: GrowthBox, to: GrowthBox) {
  const scale = Math.max(from.width / to.width, from.height / to.height)
  return {
    x: from.left + from.width / 2 - (to.width * scale) / 2 - to.left,
    y: from.top + from.height / 2 - (to.height * scale) / 2 - to.top,
    scale,
  }
}
